<template>
  <section class="primaryInfo">
    <a
      name="home"
      style="
        position: relative;
        top: -420px;
        display: block;
        height: 0;
        overflow: hidden;
      "
    ></a>
    <section class="information">
      <section class="innerBox">
        <!-- <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs> -->
        <div class="info">
          <div style="margin-bottom: 36px; margin-top: 30px;">
            <p class="simple_title">{{$t("contactus_cont_title_1")}}</p>

            <p>
              {{$t("contactus_cont_text_1")}}
              <a href="mailto:help@totok.ai">help@totok.ai</a>
            </p>
          </div>
          <div style="margin-bottom: 36px;">
            <p class="simple_title">{{$t("contactus_cont_title_2")}}</p>

            <p>
              {{$t("contactus_cont_text_2")}}
              <a href="mailto:media@totok.ai">media@totok.ai</a>
            </p>
          </div>
          <div style="margin-bottom: 36px;">
            <p class="simple_title">{{$t("contactus_cont_title_3")}}</p>

            <p>
              {{$t("contactus_cont_text_3")}}
              <a href="mailto:privacy@totok.ai">privacy@totok.ai</a>
            </p>
          </div>
          <div style="margin-bottom: 36px;">
            <p class="simple_title">{{$t("contactus_cont_title_4")}}</p>

            <p>
              {{$t("contactus_cont_text_4")}}
              <a style="margin-bottom: 40px;" href="mailto:job@totok.ai"
                >job@totok.ai</a
              >
            </p>
          </div>
          <div style="margin-bottom: 36px;">
            <p class="simple_title">{{$t("contactus_cont_title_5")}}</p>
            <p>
              {{$t("contactus_cont_text_5")}}
              <a href="https://twitter.com/ToTokMessenger">ToTokMessenger</a>
            </p>
          </div>
        </div>
        <!-- <div
          class="cp"
          style="position: absolute;bottom: 0px;left: 0px;width: 100%;margin: 0 auto;"
        >All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
    <Footer></Footer>
    <FootBanner v-show="!isPc && !isIOS"></FootBanner>
  </section>
</template>

<script>
import NewsBar from "@/components/NewsBar.vue";
import Footer from "@/components/Footer.vue";
import NavCrumbs from "@/components/NavCrumbs.vue";
import FootBanner from "@/components/FootBanner.vue";
export default {
  metaInfo() {
    return {
      title: "About Us",
      meta: [
        { property: "og:title", content: "About Us" },
        { property: "og:description", content: "About Us" },
        { property: "og:url", content: "https://totok.ai/contactus" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NewsBar,
    Footer,
    NavCrumbs,
    FootBanner,
  },
  data() {
    return {
      crumbProp: {
        label: "Contact us",
        type: "simple",
      },
      showinfo: false,
      isActive: "Jan05",
      leftMenus: [
        {
          title: "Jan 05",
          anchorId: "Jan05",
        },
        {
          title: "Dec 29",
          anchorId: "Dec29",
        },
        {
          title: "Dec 27",
          anchorId: "Dec27",
        },
        {
          title: "Dec 24",
          anchorId: "Dec24",
        },
        {
          title: "Dec 23",
          anchorId: "Dec23",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  mounted() {},
  methods: {
    gotoHandle(palice) {
      console.log("palice", palice);
      switch (palice) {
        case "Jan05":
          this.isActive = "Jan05";
          this.$router.push({ name: "newsJan05" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec29":
          this.isActive = "Dec29";
          this.$router.push({ name: "newsDec29" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec27":
          this.isActive = "Dec27";
          this.$router.push({ name: "newsDec27" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec24":
          this.isActive = "Dec24";
          this.$router.push({ name: "newsDec24" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec23":
          this.isActive = "Dec23";
          // this.$router.push({name:'newsDec22'})
          // this.mainPannel.scrollTo(0, 0)
          this.$router.push({ name: "newsDec22" });
          break;
      }
    },
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
  .primaryInfo {

    background: #fff;
    height: auto;

    .innerBox {
      position: relative;
      padding-bottom: 50px;
      min-height: 80vh;
    }

    .leftMenu {
      display: none;
    }

    div {
      margin-left: 20px;
      margin-right: 20px;
    }

    .info {
      h1 {
        font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 28px;
        font-weight: 400;
        color: #222222;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 20px;
        padding-top: 40px;
        margin: 0px;
        line-height: 40px;
      }

      h2 {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 24px;
        font-weight: 400;
        color: #4377f2;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 18px;
        padding-top: 28px;
        margin: 0px;
      }

      h3 {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: 400;
        color: #808080;
        padding-bottom: 20px;
        margin: 0;
      }

      h6 {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-style: italic;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      p {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      ul {
        list-style: disc;
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0;
        margin-bottom: 10px;
        margin-left: 24px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      li {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0px;
        margin-bottom: 10px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
        margin-left: 20px;
      }

      a {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #4377f2;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      .main_title {
        direction: ltr;
        // font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        text-align: left;
        border: 0;
        margin: 0;
        padding: 0;
        vertical-align: baseline;
        color: #32373b;
        font-size: 26px;
        font-weight: 600;
        line-height: 31px;
        margin-bottom: 51px;
        margin-left: 20px;
        margin-top: 36px;
      }

      .simple_title {
        direction: ltr;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        text-align: left;
        border: 0;
        margin: 0;
        padding: 0;
        vertical-align: baseline;
        margin-bottom: 26px;
        color: #32373b;
        font-weight: 400;
        line-height: 26px;
        font-size: 24px;
      }
    }
  }

  .cp {
    height: 3.5rem;
    font-size: 13px;
    color: #808080;
    line-height: 3.5rem;
    text-align: center;
  }
}

@media only screen and (min-width: 701px) {
  .primaryInfo {
    padding-top: 86px;
    width: 100vw;
    background: #fff;

    .information {
      margin: 0 auto;
      width: 1024px;

      .innerBox {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        min-height: 83vh;
        overflow: auto;

        .leftMenu {
          position: absolute;
          left: 0px;
          top: 39px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          list-style: none;

          .menu-item {
            color: #979797;
            margin-top: 30px;
            cursor: pointer;
            text-decoration: none;
            font-size: 15px;
          }

          .menu-item:nth-child(1) {
            margin-top: 0px;
          }

          .menu-item--active {
            color: #000;
            border-bottom: 2px solid #4377f2;
          }
        }
      }
    }

    .info {
          width: 100%;
    max-width: 800px;
    margin: 20px 0;

      h1 {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 28px;
        font-weight: 400;
        color: #222222;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 20px;
        padding-top: 20px;
        margin: 0px;
        line-height: 40px;
      }

      h2 {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 24px;
        font-weight: 400;
        color: #4377f2;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 18px;
        padding-top: 28px;
        margin: 0px;
      }

      h3 {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: 400;
        color: #808080;
        padding-bottom: 20px;
        margin: 0;
      }

      h6 {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-style: italic;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      p {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      ul {
        list-style: disc;
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0;
        margin-bottom: 10px;
        margin-left: 24px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      li {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0px;
        margin-bottom: 10px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
        margin-left: 20px;
      }

      a {
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #4377f2;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      .main_title {
        direction: ltr;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        text-align: left;
        border: 0;
        margin: 0;
        padding: 0;
        vertical-align: baseline;
        color: #32373b;
        font-size: 26px;
        font-weight: 300;
        line-height: 31px;
        margin-bottom: 51px;
      }

      .simple_title {
        direction: ltr;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        text-align: left;
        border: 0;
        margin: 0;
        padding: 0;
        vertical-align: baseline;
        margin-bottom: 16px;
        color: #32373b;
        font-weight: 400;
        line-height: 26px;
        font-size: 24px;
      }
    }
  }

  .cp {
    height: 70px;
    font-size: 13px;
    color: #808080;
    line-height: 70px;
    text-align: center;
  }
}
</style>
